import styles from '/builds/sitegeist/bad-toelz-de/.build/releases/1/DistributionPackages/BadToelz.BadToelzDe/Resources/Private/Fusion/Presentation/Components/SitemapList/SitemapList.css';

export const prototypeName = 'DLwVpQRj0bCyKkRGqd2eSjOMMqbaGnSqljKjqR1jIaLRGdbakPIQjDldWZQeHgQl4GMezM';
export {styles};